import { render, staticRenderFns } from "./curriculum.vue?vue&type=template&id=6cf39501&"
import script from "./curriculum.vue?vue&type=script&lang=ts&"
export * from "./curriculum.vue?vue&type=script&lang=ts&"
import style0 from "./curriculum.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports